import { render, staticRenderFns } from "./setting-menu.vue?vue&type=template&id=81eeb3d4&"
import script from "./setting-menu.vue?vue&type=script&lang=js&"
export * from "./setting-menu.vue?vue&type=script&lang=js&"
import style0 from "./setting-menu.vue?vue&type=style&index=0&id=81eeb3d4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports